export const getValidatedValue = (
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
newValue, oldValue, max, min) => {
    const newNumber = +newValue;
    if (isNaN(newNumber)) {
        return oldValue;
    }
    if (!isNaN(max) && newNumber > max) {
        return max;
    }
    if (!isNaN(min) && newNumber < min) {
        return min;
    }
    return Math.round(newNumber);
};
export const calculateValue = (type, value, increment, max, min) => {
    const factor = type === "decrement" ? -1 : 1;
    const newValue = value + factor * increment;
    return getValidatedValue(newValue, value, max, min);
};
export const getNumberValue = (string) => {
    const number = string === "" ? NaN : +string;
    return number;
};
//# sourceMappingURL=number-input-utils.js.map
